import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { leftArrow, rightArrow, certiIcon } from "../../../constants/icons";
import Card from "olive-react-myoneui/lib/Card";
import CertificateItem from "./CertificateItem";
import { useDispatch, useSelector } from "react-redux";
import { setConfigData } from "../../../../reducers/configSlice";
import { getCertificates } from "../../../../api/afterLogin/certificates";
import { Row } from "olive-react-myoneui";
import NoItemsInfo from "../NoItemsInfo";
import { CertificateItemLoader } from "../../Loader";

const CertificatesCarousel = ({ className, setHasError }) => {
  const dispatch = useDispatch();
  const learnerData   = useSelector((state) => state.user.user);
  const configData      = useSelector((state) => state.config);
  const adminData = useSelector((state) => state.admin);
  const learner       = configData.session;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [certificateData, setCertificateData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const ref = useRef(null);

  const fetch_certificates = async () => {
    try {
      const products = adminData.products ?? [];
      if(products.length > 0) {
        const certificates = await getCertificates(learner.id, learner.us_uuid, configData.access_token, products);
        setCertificateData(certificates);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setHasError(true);
      console.error(error);
    }
  }

  useEffect(() => {
    fetch_certificates();
  },[adminData]);

  dispatch(setConfigData({certificatecount: certificateData.length }));

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 2,
    afterChange: (current) => setCurrentSlide(current),
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          variableWidth: false,
        },
      },
      {
        breakpoint: 1368,
        settings: {
          slidesToShow: 2,
          variableWidth: false,
        },
      },
    ],
  };

  const handleNextSlide = () => ref.current.slickNext();
  const handlePrevSlide = () => ref.current.slickPrev();

  const isAtStart = currentSlide === 0;
  const isAtEnd = currentSlide >= certificateData.length - settings.slidesToShow;

  return (
    <Card className="myk__stu-certificates-wrapper pb-2 mb-4">
      <Card.Header className="mb-3">
        <h2>
          {certiIcon} Certificates <span className="myk__stu-learner-counter">{certificateData.length}</span>
        </h2>
      </Card.Header>
      <div className={`${className || ''} myk__stu-cert-carousel-wrapper`}>
        <div className="myk_stu-carousel-action">
          <span
            className={`btn-move btn-prev ${isAtStart ? 'disabled' : ''}`}
            onClick={handlePrevSlide}
            disabled={isAtStart}
          >
            {leftArrow}
          </span>
          <span
            className={`btn-move btn-next ${isAtEnd ? 'disabled' : ''}`}
            onClick={handleNextSlide}
            disabled={isAtEnd}
          >
            {rightArrow}
          </span>
        </div>
        {isLoading ? (
            <Row>
              <CertificateItemLoader items={3} />
            </Row>
            ) : certificateData.length === 0 ? (
              <NoItemsInfo 
                className="myk__stu-empty-com_cert" 
                title="No Certificates!"
                description="Your certificates will appear here." 
              />
            ) : (
            <Slider {...settings} ref={ref}>
              {certificateData && certificateData.map((certificate, index) => {
                const fileType = certificate.certificate_url.endsWith('.pdf') ? 'pdf' : 'image';
                return (
                  <CertificateItem
                    key={index}
                    fileType={fileType}
                    file={certificate.certificate_url}
                    title={certificate.course_title}
                    issuedate={certificate.issued_date}
                  />
                );
              })}
            </Slider>
          )}
      </div>
    </Card>
  );
};

export default CertificatesCarousel;
